import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	appStoreLabel: {
		id: 'premiumConfirmation.appStoreLabel',
		defaultMessage: 'Button to download Calm in the app store',
		description: 'Heading for recommended sleep',
	},
	subHeading: {
		id: 'premiumConfirmation.subHeading',
		defaultMessage:
			'You’re in. Now download the Calm app to discover the full range of Calm’s features and benefits.',
		description: 'Heading for recommended sleep',
	},
	handoffHeader: {
		id: 'premiumConfirmation.welcome.title',
		defaultMessage: 'Welcome to Calm Premium!',
		description: 'Welcome message for members with Calm Premium subscriptions',
	},
	lifetimeWelcome: {
		id: 'premiumConfirmation.welcome.lifetimeTitle',
		defaultMessage: 'Congrats! Your lifetime subscription is active.',
		description: 'Welcome message for members with lifetime subscriptions',
	},
	nonPremiumWelcome: {
		id: 'premiumConfirmation.welcome.nonPremiumTitle',
		defaultMessage: 'Congrats! Your Calm subscription is active.',
		description: 'Welcome message for members with normal subscriptions',
	},
	lifetimeCancelCTA: {
		id: 'premiumConfirmation.cancel',
		defaultMessage:
			'If you originally subscribed to Calm Premium through iTunes or the Google Play Store, you need to <cancellink>cancel your subscription</cancellink> with them to stop being charged by them in the future. Upgrading to lifetime access through our website does not automatically cancel prior in-app subscription purchases.',
		description: "Explain to the user that web subscriptions can't auto-cancel mobile subscriptions",
	},
	qrCodeInstructions: {
		id: 'premiumConfirmation.qrCodeInstructions',
		defaultMessage: 'Scan this QR code to download Calm’s mobile app.',
		description: 'Instructions for the user to download via QR code',
	},
	toAppStore: {
		id: 'premiumConfirmation.toAppStore',
		defaultMessage: 'Go to the App Store',
		description: 'aria label for button for the user to go to the App Store',
	},
});

export default messages;
